import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-projcts',
  templateUrl: './all-projcts.component.html',
  styleUrls: ['./all-projcts.component.scss']
})
export class AllProjctsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
